import _classCallCheck from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 -8px;\n  padding: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { Component } from 'react';
import styled from 'styled-components';
import { focusById } from '@scp/ui-shared/theme/utils';
import { color } from '@scp/ui-shared/theme/variables';
import { Icon } from '@scp/ui-shared/theme/icons';
import { IconButton } from '@scp/ui-shared/components/buttons';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { VisuallyHiddenElement } from '@scp/ui-shared/theme/resets';
var TEXT = {
  LABEL: function LABEL(label) {
    return label ? "Clear ".concat(label, " value") : 'Clear the Value';
  }
};
var E2E_CLEAR_BUTTON_SUFFIX = '-field-clear-button';
var IndicatorButton = styled(IconButton).attrs({
  tabIndex: 0,
  title: TEXT.LABEL()
})(_templateObject());
export var ClearButton = /*#__PURE__*/function (_Component) {
  _inherits(ClearButton, _Component);

  var _super = _createSuper(ClearButton);

  function ClearButton() {
    var _this;

    _classCallCheck(this, ClearButton);

    _this = _super.apply(this, arguments);
    /**
     * `onMouseDown` event on `react-select` opens the dropdown.
     * Button is inside `react-select` tree, on click it the bubbles event and opens the dropdown.
     *
     * Dropdown should not be opened clicking clear, so bubbling is disabled.
     */

    _this.handleMouseDown = function (e) {
      return e.stopPropagation();
    };

    _this.handleClick = function () {
      _this.props.onClick();

      focusById(_this.props.inputId);
    };

    _this.handleKeyDown = function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') {
        e.preventDefault();

        _this.handleClick();
      }
    };

    return _this;
  }

  _createClass(ClearButton, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          onClick = _a.onClick,
          inputId = _a.inputId,
          label = _a.label,
          otherProps = __rest(_a, ["onClick", "inputId", "label"]);

      return React.createElement(React.Fragment, null, React.createElement(IndicatorButton, Object.assign({}, otherProps, {
        "aria-labelledby": "".concat(inputId, "-clear-btn"),
        onClick: this.handleClick,
        dataE2e: getE2eLabel(inputId, E2E_CLEAR_BUTTON_SUFFIX),
        // OtherProps contains onMouseDown from Select itself.
        // @TODO: remove when there are no known issues
        // onMouseDown={this.handleMouseDown}
        onKeyDown: this.handleKeyDown
      }), React.createElement(Icon, {
        name: "clear",
        color: color.icon,
        size: 24
      })), React.createElement(VisuallyHiddenElement, {
        id: "".concat(inputId, "-clear-btn")
      }, TEXT.LABEL(label)));
    }
  }]);

  return ClearButton;
}(Component);